<ng-sidebar-container (onBackdropClicked)="_onBackdropClicked()">
  <ng-sidebar [(opened)]="_opened" [mode]="'over'" [closeOnClickOutside]="_closeOnClickOutside" [position]="'right'">
    <button class="demo-control" (click)="_toggleOpened()">
      <svg height="311pt" viewBox="0 0 311 311.07733" width="311pt" xmlns="http://www.w3.org/2000/svg">
        <path
          d="m16.035156 311.078125c-4.097656 0-8.195312-1.558594-11.308594-4.695313-6.25-6.25-6.25-16.382812 0-22.632812l279.0625-279.0625c6.25-6.25 16.382813-6.25 22.632813 0s6.25 16.382812 0 22.636719l-279.058594 279.058593c-3.136719 3.117188-7.234375 4.695313-11.328125 4.695313zm0 0" />
        <path
          d="m295.117188 311.078125c-4.097657 0-8.191407-1.558594-11.308594-4.695313l-279.082032-279.058593c-6.25-6.253907-6.25-16.386719 0-22.636719s16.382813-6.25 22.636719 0l279.058594 279.0625c6.25 6.25 6.25 16.382812 0 22.632812-3.136719 3.117188-7.230469 4.695313-11.304687 4.695313zm0 0" />
      </svg>
    </button>
    <div class="sidenav-options">
      <ul>
        <li routerLink="" (click)="_toggleOpened()" tabindex="-1" routerLinkActive="active" closeSidebar class=""><a>{{ 'Home' | translate }}</a></li>
        <!-- <li routerLink="dashboard" routerLinkActive="active" class=""><a>{{ "Login" | translate }} </a></li> -->
        <!-- <li><a routerLink="" routerLinkActive="active"> {{ "Logout" | translate }} </a></li> -->
        <li routerLink="dashboard" routerLinkActive="active" closeSidebar class=""><a>{{ 'My Reported Pets' | translate
            }}</a></li>
        <li><a class="a-menu-dropdown" href="" (click)="ReportAddRemove();" [ngClass]="report ? 'open' : ''">{{ 'Report'
            | translate }} </a>
          <ul class="menu-dropdown">
            <li routerLinkActive="active" closeSidebar class=""><a href='{{lostPath}}'>{{ 'Report Lost Pet'
                |
                translate }}</a></li>
            <li routerLinkActive="active" closeSidebar class=""><a href='{{foundPath}}'>{{ 'Report Found Pet'
                |
                translate }}</a></li>
          </ul>
        </li>
        <!-- <li><a class="a-menu-dropdown" href="" (click)="ListAddRemove();" [ngClass]="list ? 'open' : ''">{{'Browse' |
            translate}} </a>
          <ul class="menu-dropdown">
            <li routerLink="list-pets" [queryParams]="{ OperationTypeID:1,radiousDistance:10, callingFrom:'menu'}"
              routerLinkActive="active" closeSidebar class=""><a
                href="list-pets?OperationTypeID=1&radiousDistance=10&callingFrom=menu">{{ 'Browse Lost Pets' |
                translate }}</a></li>
            <li routerLink="list-pets" [queryParams]="{ OperationTypeID:2,radiousDistance:10, callingFrom:'menu'}"
              routerLinkActive="active" closeSidebar class=""><a
                href="list-pets?OperationTypeID=2&radiousDistance=10&callingFrom=menu">{{ 'Browse Found Pets' |
                translate }}</a></li>        
          </ul>
        </li> -->
        <!-- <li><a class="a-menu-dropdown" href="" (click)="StaticAddRemove();" [ngClass]="static ? 'open' : ''">{{'About'|
            translate}} </a>
          <ul class="menu-dropdown">
            <li routerLinkActive="active" closeSidebar class=""><a target="_blank"
                href="https://www.dyreid.no/idmerking/kjaeledyr-mikrochip.html">{{ 'About Us' | translate }}</a></li>
            <li routerLinkActive="active" closeSidebar class=""><a target="_blank" href="https://www.dyreid.no">{{
                'Services' | translate }}</a></li>
            <li routerLink="termsandconditions" routerLinkActive="active" closeSidebar class=""><a>{{ 'Terms &
                Conditions' | translate }}</a></li>
            <li routerLink="privacypolicy" routerLinkActive="active" closeSidebar class=""><a>{{ 'Privacy Policy' |
                translate }}</a></li>
          </ul>
        </li> -->
        <!-- <li><a href="userprofile">{{ 'User Profile' | translate }}</a></li> -->
        <!-- <li *ngIf="currentUser"> <a onclick="signOut()">{{ 'Logout' | translate }}</a></li> -->
        <!-- href="privacypolicy">{{ 'Privacy Policy' | translate }}</a></li> -->
        <!-- <li><a target="_blank" href="https://www.dyreid.no/hjelpesenter.html">{{ 'Contact Us' | translate }}</a></li> -->
      </ul>
    </div>
  </ng-sidebar>
  <div ng-sidebar-content>
    <app-header></app-header>
    <div class="profile-form" [hidden]="this.router.url == '/'">
      <div class="container" *ngIf="!currentPath.includes('login')">
        <xng-breadcrumb [autoGenerate]="false" [separator]="iconTemplate">
          <ng-container *xngBreadcrumbItem="let breadcrumb; let info = info; let first = first">
            <mat-icon *ngIf="info">{{ info.icon }}</mat-icon>
            <!-- <ng-container *ngIf="!first">{{ breadcrumb |translate}}</ng-container> -->
            <ng-container>{{ breadcrumb |translate}}</ng-container>
          </ng-container>
        </xng-breadcrumb>
      </div>
    </div>
    <router-outlet (activate)="onActivate($event)"></router-outlet>
    <footer id="footer" class="footer-sec mt-5">
      <div class="container">
        <div class="row">
          <div class="col-sm-9">
            <div class="footer-descrp" id="footer-section">
              <h2>DyreID</h2>
              <p>DyreID er eiet av Den norske veterinærforening og forvalter registeret over alle ID-merkede kjæledyr i
                Norge. I tillegg til ID-merkingen tilbyr vi tjenester som Mitt Spor sporingsenhet, helsedata gjennom
                Diagnoseregisteret, DNA-tjenester og Savnet & Funnet.
                Alt for å sikre og bidra til ditt kjæledyrs helse, trygghet og dyrevelferd.</p>
                
            </div>
          </div>
          <div class="col-sm-3">
            <div class="footer-link">
              <ul>
                <li> <a href="https://www.dyreid.no" target="_blank">{{'Services' | translate}}</a> </li>
                <li><a href="https://www.dyreid.no/idmerking/kjaeledyr-mikrochip.html">Om ID-merking </a></li>
                <li><a href="javascript:void(0)" (click)="open(tandc)" target="blank">{{'Terms & Conditions' |
                    translate}}</a></li>
                <li><a href="javascript:void(0)" (click)="openPrivacyPolicy()">{{ 'Privacy Policy' |
                    translate }}</a></li>
                <!-- <li routerLink="privacypolicy" routerLinkActive="active" closeSidebar class=""><a></a></li> -->
                <!-- <li> <a href="https://www.dyreid.no/hjelpesenter.html" target="_blank">{{'Contact Us' | translate }}</a> -->
                <li> <a href="https://www.dyreid.no/help-savnet-og-funnet.html" target="_blank">{{'Contact Us' |
                    translate }}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</ng-sidebar-container>

<ng-template #iconTemplate>
  <mat-icon>arrow_right</mat-icon>
</ng-template>

<div class="tandc">
  <ng-template #tandc let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">{{'Terms and Conditions'| translate}}</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="text-center col-md-12">
        <h2>BRUKERVILKÅR FOR SAVNET OG FUNNET</h2>
        <p>De følgende brukervilkårene regulerer din tilgang til og bruk av tjenesten Savnet og Funnet ("Tjenesten").
          Tjenesten leveres av DyreID AS. Ved å trykke aksepter bekrefter du at du har lest og godtar disse vilkårene.
          <br />

          Ved vesentlige endringer av vilkårene vil du få varsel sendt til din registrerte epostadresse innen rimelig
          tid
          før de nye endringene trer i kraft.
        </p>

        <h4>1. OM TJENESTEN</h4>
        <p>Tjenesten er en løsning som tilbys av DyreID AS for at savnede kjæledyr lettere skal kunne finnes. Tjenesten
          gir privatpersoner, organisasjoner og andre relevante aktører ("Brukerne") adgang til å annonsere dyr som
          savnet
          eller funnet via DyreIDs Savnet og Funnet-kanaler.<br />

          Du kan registrere deg for Tjenesten ved å opprette en Savnet og Funnet-bruker her. Dersom du allerede har
          opprettet en Min Side-bruker hos DyreID, kan du registrere deg via din eksisterende brukerprofil. Du kan også
          logge deg inn på Tjenesten via sosiale medier (Facebook, Google og andre relevante kanaler).</p>
        <h4>2 BRUK AV SAVNET OG FUNNET</h4>
        <p>Tjenesten benyttes på eget ansvar. Dersom man benytter seg av Tjenesten i strid med disse vilkårene eller
          brukerens bruk eller misbruk ellers medfører ulemper for DyreID, kan DyreID kreve erstatning for sine tap.
          <br />

          DyreID tar ikke ansvar for innhold som lagres eller distribueres via Tjenesten. DyreID forbeholder seg retten
          til å fjerne eller nekte å distribuere innhold på Tjenestene, samt å si opp Brukere som ikke overholder
          brukervilkårene. Ved å godkjenne disse vilkårene forplikter du deg til å ikke laste opp bilder eller tekst som
          har et upassende innhold (f.eks. seksualiserende eller støtende innhold). <br />

          Brukere som registrerer dyret sitt i Tjenesten må oppgi riktige opplysninger om navn, adresse, telefonnummer
          og
          andre nødvendige opplysninger. Brukere som legger inn uriktige eller manglende opplysninger, kan risikere å få
          dyret fjernet fra listen over savnede dyr. <br />

          Brukerne er ansvarlige for å holde status på dyreannonsen løpende oppdatert. En annonse vil bli markert som
          "løst" eller "gjenforent" dersom Brukeren (i) ikke har endret status på dyret eller utvidet savnet-perioden
          innen 28 dager fra datoen annonsen ble registrert, eller (ii) selv har markert eller rapportert at dyret er
          funnet.
        </p>
        <h4>3 PERSONVERN</h4>
        <p>I forbindelse med bruken av Tjenesten vil DyreID behandle personopplysninger om Brukerne. Denne behandlingen
          er
          nærmere beskrevet i DyreIDs personvernerklæring.</p>
        <h4>4 KOMMUNIKASJON MED BRUKERNE</h4>
        <p>Du kan selv velge om du vil tilgjengeliggjøre din egen kontaktinformasjon når du legger ut en annonse i
          Tjenesten. Hvis du ikke velger å tilgjengeliggjøre kontaktinformasjonen din, vil all kommunikasjon mellom deg
          og
          andre Brukere gå via DyreID. DyreID er ikke ansvarlig for innholdet i kommunikasjonen som videreformidles i
          denne forbindelse. <br />

          Brukere som ønsker å respondere på en savnet-annonse og rapportere inn et dyr som funnet, må enten bruke
          kontaktskjemaet som ligger i Tjenesten eller den publiserte kontaktinformasjonen til den Brukeren som har
          annonsert dyret som savnet. Av sikkerhetshensyn vil IP-adresser bli logget i forbindelse med kommunikasjon med
          Brukerne av Tjenesten.</p>
      </div>
    </div>
  </ng-template>
</div>